<!--
  Sección de una página legal: tarjeta con chip de ícono, número opcional y
  título. Las páginas de políticas eran una secuencia de <h4> + <p> sobre fondo
  plano; esto les da el mismo lenguaje de tarjetas que ya usaba /servicios sin
  tocar el texto legal.

  El cuerpo va por slot para que la prosa siga heredando los estilos profundos
  de LegalPage (`.legal-content >>> p`, `>>> ul`, `>>> a`).
-->
<template>
  <section class="legal-section">
    <div class="legal-section__head">
      <div
        class="legal-section__icon"
        :class="`legal-section__icon--${variant}`"
      >
        <feather-icon
          :icon="icon"
          size="18"
        />
      </div>
      <div class="legal-section__heading">
        <span
          v-if="step"
          class="legal-section__step"
        >{{ step }}</span>
        <h3 class="legal-section__title mb-0">
          {{ title }}
        </h3>
      </div>
    </div>

    <div class="legal-section__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "FileTextIcon" },
    // Cualquiera de los tintes de la paleta: primary, info, success, warning,
    // danger. Se usa para el chip del ícono, no para el texto.
    variant: { type: String, default: "primary" },
    // El número que traía el título ("1. Objeto"): sale del texto y va al chip.
    step: { type: String, default: "" },
  },
}
</script>

<style lang="scss" scoped>
.legal-section {
    padding: 1.375rem;
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius);
    background-color: var(--tm-surface);
}

.legal-section__head {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    margin-bottom: 0.875rem;
}

.legal-section__icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: var(--tm-radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;

    &--primary {
        background-color: rgba(var(--tm-primary-rgb), var(--tm-tint));
        color: var(--tm-primary);
    }

    &--info {
        background-color: rgba(var(--tm-info-rgb), var(--tm-tint));
        color: var(--tm-info);
    }

    &--success {
        background-color: rgba(var(--tm-success-rgb), var(--tm-tint));
        color: var(--tm-success);
    }

    &--warning {
        background-color: rgba(var(--tm-warning-rgb), var(--tm-tint));
        color: var(--tm-warning);
    }

    &--danger {
        background-color: rgba(var(--tm-danger-rgb), var(--tm-tint));
        color: var(--tm-danger);
    }
}

.legal-section__heading {
    min-width: 0;
}

.legal-section__step {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--tm-text-muted);
    letter-spacing: 0.08em;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
}

.legal-section__title {
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--tm-text);
}
</style>
